// Design tokens shared with the mobile app (Prembid_Mobile_New src/theme/tokens.ts): a clean light base, white cards
// with a hairline border, pill buttons and inputs. The vendor brand colour (settings.Styles.Primary) is the accent.

export const palette = {
  page: "#F3F5F7",
  surface: "#FFFFFF",
  surfaceMuted: "#F6F7F9",
  border: "#E4E7EB",
  borderStrong: "#D3D8DE",
  text: "#0F1419",
  textMuted: "#5B6570",
  textFaint: "#8A939C",
  ink: "#16191C",
  inverse: "#FFFFFF",
  success: "#1F9D55",
  danger: "#E5484D",
  warning: "#F5A524",
  info: "#0EA5C6",
};

export const radius = {
  sm: 8,
  md: 12,
  lg: 18,
  xl: 24,
  pill: 999,
};

export const spacing = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  xxl: 24,
};

export const shadow = {
  card: "0 4px 10px rgba(15, 20, 25, 0.06)",
  float: "0 8px 20px rgba(15, 20, 25, 0.12)",
};

// #RRGGBB + alpha (0-1) -> rgba(); falls back to the input for anything else.
export const withAlpha = (hex: string, alpha: number) => {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex ?? "");
  if (!m) return hex;
  return `rgba(${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}, ${alpha})`;
};

// Black or white text, whichever reads better on the given background.
export const readableOn = (hex: string) => {
  const m = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(hex ?? "");
  if (!m) return palette.inverse;
  const [r, g, b] = [m[1], m[2], m[3]].map((x) => parseInt(x, 16) / 255);
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.6 ? palette.ink : palette.inverse;
};
